var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMemo } from "react";
import { useQuery } from "react-query";
import { CasCustomAttrsApi, sortCustomAttributes } from "@jti/rest-api";
export const useCustomAttributes = () => {
    const casCustomAttrsApi = CasCustomAttrsApi.init();
    const { isLoading: isLoadingCustomAttrs, data: additionalFields } = useQuery("getCustomAttributes", () => __awaiter(void 0, void 0, void 0, function* () {
        return yield casCustomAttrsApi.getCustomAttributes();
    }), {
        staleTime: Infinity,
        retry: false,
    });
    const orderedCustomAttributes = useMemo(() => {
        return sortCustomAttributes((additionalFields === null || additionalFields === void 0 ? void 0 : additionalFields.data) || []);
    }, [additionalFields]);
    return {
        isLoadingCustomAttrs,
        additionalFields,
        orderedCustomAttributes,
    };
};
